import { render, staticRenderFns } from "./event-sign.vue?vue&type=template&id=24983f18&"
import script from "./event-sign.vue?vue&type=script&lang=js&"
export * from "./event-sign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports